export const ROUTES = Object.freeze({
  ROOT: '/',
  PRICING: '/pricing',
  LOGIN: '/login',
  LOGIN_CALLBACK: '/login/callback',
  ADMIN: Object.freeze({
    ROOT: '/admin',
    DASHBOARD: '/admin/dashboard',
    PROFILE: '/admin/profile',
    SUBSCRIPTION: '/admin/subscription',
    API_KEYS: '/admin/api-keys',
    REPOSITORIES: '/admin/repositories',
    CLOUD: '/admin/cloud',
    TEAMS: '/admin/teams',
    ANALYTICS: '/admin/analytics',
    EVENTS: '/admin/events',
  }),
});
